"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const ar_1 = __importDefault(require("date-fns/locale/ar")); //
const dateArDZ = {
    name: 'ar-DZ',
    locale: ar_1.default
};
exports.default = dateArDZ;
